import { Component, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { IoGlobals } from './ioglobals';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnDestroy {

    public connect: any;

    constructor(
        public translate: TranslateService,
        public IO: IoGlobals,
        private title: Title
    ) {

        translate.addLangs(['vi']);

        translate.setDefaultLang('vi');

        const browserLang = translate.getBrowserLang();

        translate.use(browserLang.match(/vi/) ? browserLang : 'vi');

        this.IO.ini();

        this.connect = this.IO.result.subscribe((res: any) => {
            if (res.token == this.IO.config.token.company) {
                let data = res.data;

                if (data.shortcut) {
                    data.shortcut = (!data.shortcut.includes('public/website/')) ? (this.IO.BASE_API_URL + 'public/website/' + data.shortcut) : data.shortcut;
                }
                if (data.logo) {
                    data.logo = (!data.logo.includes('public/website/')) ? (this.IO.BASE_API_URL + 'public/website/' + data.logo) : data.logo;
                    this.IO.logo = data.logo;
                }
                let shortcut = document.querySelector("[type='image/x-icon']");
                if (shortcut && data.shortcut) {
                    shortcut.setAttribute('href', data.shortcut);
                }
                this.title.setTitle(data.title);
            }
        });
        this.IO.config.company();
    }

    ngOnDestroy() {
        if (this.connect) {
            this.connect.unsubscribe();
        }
    }
}
